import { observable, action } from "mobx"
import utils from '../utils'
const { FE, $ } = utils

class CarInfo {
  @observable
  isShow = false

  @observable
  preferCar = {
    brandId: 0,
    brandName: '',
    seriesId: 0,
    seriesName: ''
  }

  @observable
  shouldLoadHot = false

  @observable
  info = {
    brandId: 0,
    brandName: '',
    seriesId: 0,
    seriesName: ''
  }

  @action.bound
  show() {
    this.isShow = true
  }

  @action.bound
  hide() {
    let body = document.body
    if(body.getAttribute('canRelex') === 'yes'){
      body.style.position = 'static'
      let top = body.style.top
      document.body.scrollTop = document.documentElement.scrollTop = -parseInt(top)
      body.style.top = ''
      body.setAttribute('canRelex','no')
    }
    this.isShow = false
  }

  @action.bound
  changeCar(newCar) {
    this.info = newCar
  }

  @action.bound
  clearSelCar() {
    this.info = {
      brandId: 0,
      brandName: '',
      seriesId: 0,
      seriesName: ''
    }
  }

  @action.bound
  setPrefer(prefe) {
    this.preferCar = prefe
  }

  @action.bound
  hotHandler(state) {
    this.shouldLoadHot = state
  }
}

export default new CarInfo()


// WEBPACK FOOTER //
// ./src/stores/CarInfo.js